import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../../store/store";

import { levelTextById } from "../../../../Utils/get-sound-level";

import "./SoundsGroupInformation.component.scss";

export interface SoundsGroupInformationProps {
    open: boolean;
}

class SoundsGroupInformation extends Component<
    SoundsGroupInformationProps,
    {}
> {
    render() {
        return (
            <div
                id="soundsGroupsInformation"
                className={this.props.open ? `open` : ""}
            >
                <div>
                    <div className="row info-groups-tables">
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Group 1 - Gameplay</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="sub-header border-light-right">
                                            Bingo
                                        </td>
                                        <td className="sub-header">Spins</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Button press</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Tension</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Prizes</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>Credit Run-up</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            One Away
                                        </td>
                                        <td>Spin</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Ball Extraction
                                        </td>
                                        <td>Free Spin Symbol</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Extra Ball
                                        </td>
                                        <td>Wild Symbol</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Free Ball
                                        </td>
                                        <td>Scatter Symbol</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="row info-groups-tables">
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>
                                            Group 2 - Big Prizes
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="sub-header border-light-right">
                                            Bingo
                                        </td>
                                        <td className="sub-header">Spins</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Jackpot
                                        </td>
                                        <td>Mega Jackpot</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Bingo
                                        </td>
                                        <td>Grand Jackpot</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            High Prize 1
                                        </td>
                                        <td>Major Jackpot</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            High Prize 2
                                        </td>
                                        <td>Minor Jackpot</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            -
                                        </td>
                                        <td>Mini Jackpot</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            -
                                        </td>
                                        <td>Big Win</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            -
                                        </td>
                                        <td>High Prize 1</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            -
                                        </td>
                                        <td>High Prize 2</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="row info-groups-tables">
                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>
                                            Group 3 - Collective Prizes
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="sub-header border-light-right">
                                            Bingo
                                        </td>
                                        <td className="sub-header">Spins</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Mr Champion
                                        </td>
                                        <td>Mr Champion</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Pig Boom
                                        </td>
                                        <td>Pig Boom</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Champ-on-Time
                                        </td>
                                        <td>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div>
                            <table>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Group 4 - Bonus</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="sub-header border-light-right">
                                            Bingo
                                        </td>
                                        <td className="sub-header">Spins</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Bonus 1
                                        </td>
                                        <td>Free Spins</td>
                                    </tr>
                                    <tr>
                                        <td className="border-light-right">
                                            Bonus 2
                                        </td>
                                        <td>Bonus 1</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SoundsGroupInformation);
